import { InputComboboxItem } from './input_combobox_item.component';
import { InputComboboxRoot } from './input_combobox_root.component';

export const InputCombobox = {
	Root: InputComboboxRoot,
	Item: InputComboboxItem,
};

export type { InputComboboxMultipleValue, InputComboboxSingleValue } from './input_combobox_root.component';
